import dvlaConfig from '../config/dvla';
import awsConfig from '../config/aws-exports';

export const getVehicle = async registrationNumber => {
  return await fetch(awsConfig.dvla_endpoint_auth, {
    method: 'post',
    headers: {
      'x-api-key': dvlaConfig.apiKey,
    },
    body: JSON.stringify({
      registrationNumber,
    }),
  })
    .then(res => res.json())
    .catch(error => console.log(error));
};

export const numberPlateRegex =
  // eslint-disable-next-line max-len
  /(^[A-Z]{2}[0-9]{2}\s?[A-Z]{3}$)|(^[A-Z][0-9]{1,3}[A-Z]{3}$)|(^[A-Z]{3}[0-9]{1,3}[A-Z]$)|(^[0-9]{1,4}\s?[A-Z]{1,2}$)|(^[0-9]{1,3}\s?[A-Z]{1,3}$)|(^[A-Z]{1,2}[0-9]{1,4}$)|(^[A-Z]{1,3}[0-9]{1,3}$)|(^[A-Z]{1,3}[0-9]{1,4}$)|(^[0-9]{3}[DX]{1}[0-9]{3}$)|(^AVERAGE$)/gm;
